import {
  ComponentsProps,
  ComponentsVariants,
  ComponentsOverrides,
} from '@mui/material';

import { NEW_COLORS } from '../colors/newColors';
const MuiInputLabelTheme: {
  defaultProps?: ComponentsProps['MuiInputLabel'];
  styleOverrides?: ComponentsOverrides['MuiInputLabel'];
  variants?: ComponentsVariants['MuiInputLabel'];
} = {
  variants: [],

  defaultProps: {
    shrink: true,
  },
  styleOverrides: {
    root: {
      transform: 'none',
      position: 'initial',
      marginBottom: 8,
      color: NEW_COLORS.GRAYSCALE[700],
      '&.Mui-focused': {
        color: NEW_COLORS.GRAYSCALE[700],
      },
      '&.Mui-required': {
        color: NEW_COLORS.SUPPORT.INDIGO[400],
        '.MuiFormLabel-asterisk': {
          color: NEW_COLORS.SUPPORT.INDIGO[400],
        },
      },
      '&.Mui-error': {
        color: NEW_COLORS.GRAYSCALE[700],
      },
    },
    asterisk: {
      color: NEW_COLORS.GRAYSCALE[700],
    },
  },
};

export default MuiInputLabelTheme;
